import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import './TermsPage.css';

const TermsPage: React.FC = () => {
  // Scroll to top on component mount
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <PageHeader 
        title="Terms of Service" 
        date={`Last updated: ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`} 
      />

      <div className="container terms-content">
        <section className="terms-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to The Caffeinated Crumb. These Terms of Service govern your use of our website and the 
            services we offer. By accessing or using our website, you agree to be bound by these Terms. 
            If you disagree with any part of the terms, you may not access the website.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>2. Use of Our Website</h2>
          <p>
            Our website is intended for informational purposes and to facilitate ordering our products and services. 
            You agree to use our website only for lawful purposes and in a way that does not infringe upon the rights of others.
          </p>
          <p>
            You are prohibited from:
          </p>
          <ul>
            <li>Using our website in any way that could disable, damage, or impair the site</li>
            <li>Using any robot, spider, or other automated device to access our website</li>
            <li>Introducing any viruses, Trojan horses, or other harmful material</li>
            <li>Attempting to gain unauthorized access to our website or its related systems</li>
          </ul>
        </section>
        
        <section className="terms-section">
          <h2>3. Products and Services</h2>
          <p>
            The Caffeinated Crumb offers various baked goods and catering services. All product descriptions, 
            including ingredients, prices, and availability, are subject to change without notice. We strive to 
            display accurate information, but we cannot guarantee that all details are 100% accurate.
          </p>
          <p>
            For catering services, specific terms and conditions may apply as specified in individual catering agreements.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>4. Orders and Payments</h2>
          <p>
            When placing an order through our contact form or other channels, you agree to provide current, complete, 
            and accurate information. Payment terms and methods will be agreed upon at the time of order placement.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>5. Allergies and Dietary Restrictions</h2>
          <p>
            While we strive to accommodate allergies and dietary restrictions, we prepare our products in a kitchen 
            that processes common allergens such as nuts, dairy, gluten, and eggs. We cannot guarantee that any item 
            is completely free of allergens. It is your responsibility to inform us of any allergies or dietary restrictions.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>6. Intellectual Property</h2>
          <p>
            The content, logo, and other visual media displayed on our website are the property of The Caffeinated Crumb 
            and protected by copyright and trademark laws. You may not use, reproduce, or distribute our content 
            without our express written permission.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>7. User Content</h2>
          <p>
            If you submit any content to our website (such as reviews, comments, or feedback), you grant us a non-exclusive, 
            royalty-free, perpetual, and irrevocable right to use, reproduce, modify, adapt, publish, and display such content.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>8. Privacy</h2>
          <p>
            Your privacy is important to us. Our <Link to="/privacy">Privacy Policy</Link> explains how we collect, use, 
            and protect your personal information.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>9. Limitation of Liability</h2>
          <p>
            The Caffeinated Crumb shall not be liable for any damages arising from the use of our website or our products 
            and services, whether direct, indirect, incidental, consequential, or punitive.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>10. Disclaimer of Warranties</h2>
          <p>
            Our website and all content are provided "as is" without warranty of any kind, either express or implied, 
            including but not limited to, the implied warranties of merchantability, fitness for a particular purpose, 
            or non-infringement.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>11. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the state where 
            The Caffeinated Crumb is registered, without regard to its conflict of law provisions.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting 
            on our website. Your continued use of our website after any changes indicates your acceptance of the modified Terms.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>13. Contact Information</h2>
          <p>
            For questions regarding these Terms, please contact us through our <Link to="/contact">Contact Form</Link>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;
